import { apiService } from './api';

export interface AuditLog {
  id: string;
  action: string;
  entityType?: string;
  entityId?: string;
  entityLabel?: string;
  description?: string;
  amount?: number;
  performedBy?: string;
  performedByName?: string;
  organizationCode?: string;
  restaurantId?: string;
  createdAt?: string;
}

export const auditLogService = {
  async list(org: string, restaurantId?: string, action?: string): Promise<AuditLog[]> {
    const response = await apiService.get<AuditLog[]>('/audit-logs', {
      org,
      ...(restaurantId && { restaurantId }),
      ...(action && { action }),
    });
    return response.data;
  },

  // Record a UI-driven sensitive action (e.g. a void/refund performed from the Orders page)
  async record(data: Partial<AuditLog> & { action: string; organizationCode: string }): Promise<AuditLog> {
    const response = await apiService.post<AuditLog>('/audit-logs', data);
    return response.data;
  },
};
